<template>
  <div class="landing-footer layout-p py-5">
    <logo
      blueviolet
      class="landing-footer__logo"
    />
    <div class="landing-footer__content">
      <div class="landing-footer__vbank">
        <div class="landing-footer__copy">
          Copyright © 2020 Vbank. All Rights Reserved.
        </div>
        <div class="landing-footer__help">
          help@vbank.com
          <span class="mx-3">|</span>
          1(800)245-56-23
        </div>
      </div>
      <div class="landing-footer__social">
        <p class="m-0">
          Follow us in social network
        </p>
        <b-img
          :src="social"
          img-alt="image"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import social from '~/assets/img/social.svg';
  import Logo from '../Logo';

  export default {
    name: 'LandingFooter',
    components: { Logo },
    data() {
      return { social }
    },
  }
</script>

<style lang="scss" src="./LandingFooter.scss" />
